import moment from "moment";

export function addDays(dias: number, date: Date) {
    return moment(date).add(dias, "days").toDate();
}

export function addSeconds(seconds: number, date: Date) {
    return moment(date).add(seconds, "seconds").toDate();
}

export function addHours(hours: number, date: Date) {
    return moment(date).add(hours, "hours").toDate();
}

export function addMonths(months: number, date: Date) {
    return moment(date).add(months, "months").toDate();
}

export function firstDayOfMonth(date: Date) {
    return moment(date).startOf("month").toDate();
}

export function lastDayOfMonth(date: Date) {
    return moment(date).endOf("month").toDate();
}

export function editDate(date: Date) {
    if (date == null) {
        return "";
    }
    return moment(Date.parse(date.toString())).format("DD/MM/YYYY");
}

export function editHourAndMinutes(date: Date) {
    if (date == null) {
        return "";
    }
    return moment(Date.parse(date.toString())).format("HH:mm");
}

export function applyTimeZoneDifference(date: Date, edit: boolean): Date {
    if (edit) {
        const localOffsetMinutes = -date.getTimezoneOffset();
        const utc3OffsetMinutes = -180; // UTC-3 em minutos

        const offsetDifference = localOffsetMinutes - utc3OffsetMinutes;

        return addMinutes(date, edit ? offsetDifference : -offsetDifference);
    }

    return new Date(date.getTime());
}

function addMinutes(date: Date, minutes: number): Date {
    return moment(date).add(minutes, "minutes").toDate();
}

export function editDateWithTime(date: Date) {
    if (date == null) {
        return "";
    }
    return moment(Date.parse(date.toString())).format("DD/MM/YYYY HH:mm:ss");
}

export function convertToDateInput(date: string, dataFinal = false) {
    return new Date(convertToDateInputString(date, dataFinal));
}

export function convertToDateInputString(date: string | object | null, dataFinal = false) {
    if (date) {
        if (dataFinal) {
            return moment(date, "DD/MM/YYYY").endOf("day").format("YYYY-MM-DDTHH:mm:ss");
        }

        return moment(date, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss");
    }
    return "";
}

export function convertToDateWithTimeInputString(date: string | object) {
    if (date) {
        return moment(date, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DDTHH:mm:ss");
    }
    return "";
}

export function editFromNow(date: Date) {
    if (date == null) {
        return "";
    }
    return moment(date).startOf("seconds").fromNow();
}

export function isAfterSomeDays(date: Date, days: number) {
    if (date == null) {
        return false;
    }

    const data = moment(date).startOf("day");
    const limite = moment().startOf("day").add(days, "days");

    return data.isAfter(limite);
}

export function isBeforeToday(date: Date) {
    if (!date) {
        return false;
    }

    const data = moment(date).startOf("day");
    const today = moment().startOf("day");

    return data.isBefore(today);
}
